/**
 * Typed API client.
 *
 * Uses openapi-fetch with the schema types auto-generated from the backend's
 * OpenAPI spec. Regenerate with:
 *
 *   make gen-api
 *
 * which hits the running backend's /schema/openapi.json.
 */
import createClient from "openapi-fetch";

import type { paths } from "../generated/api-schema";

// Dev: vite's proxy forwards /api/* → backend (see vite.config.ts).
// Prod: backend is a separate Railway service at a different subdomain;
// vite preview has no proxy, so a relative `/api` URL hits the web
// service (which returns the SPA HTML for unknown paths). Railway
// bakes VITE_API_BASE_URL into the bundle at build time
// (see infra/terraform/railway.tf).
const baseUrl = import.meta.env.VITE_API_BASE_URL || "/api";

// `credentials: "include"` is required for the session cookie to
// travel on cross-origin XHRs in prod (SPA at lingua.cardona-apps.com,
// API at api.lingua.cardona-apps.com). Without it, /auth/me etc.
// arrive cookieless and the backend never sees the post-login session.
// Harmless in dev (vite's /api proxy is same-origin).
export const api = createClient<paths>({
  baseUrl,
  credentials: "include",
});
